// fe/src/config/analytics.js
/**
 * Analytics configuration — IDs come from environment variables.
 * When an ID is empty, that channel is disabled and all its calls no-op.
 */
export const GA4_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || '';
export const FB_PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID || '';

export const isGaEnabled = () => Boolean(GA4_MEASUREMENT_ID);
export const isPixelEnabled = () => Boolean(FB_PIXEL_ID);
